import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Base from './Base';
const Li = ({
  component: Component = Base,
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Component, _extends({
  as: 'li'
}, props), children);
export default Li;